const INIT_STATE = {
  // 완료된 페이지
  completePage: [],
  appCompletePage: [],
  isShowOmniPopup: false, // 옴니청약 팝업 노출 여부
  // 이어서 하기
  isContinue: false,
  appIsContinue: false,
  isRewriteComplete: false, // 재작성 작성 완료 여부
  empNumber: '', // 담당자 id
  empName: '', // 담당자 name

  // 전자청약 시 진행한 docDataJson
  eaDocDataJson: null,

  // LP보고서
  fpReport: {
    // 실명증표
    realName: {
      afterCheckYn: false, // 실명증표 추후확인 여부 (Track2: 추후확인 불가 [false 고정])
      certType: '', // 1:주민등록증번호의경우, 2. 운전면허번호인경우 (api 수정됨)
      licenseCode: '', // 운전면허증 선택 시 지역코드
      licenseNumber: '', // 면허번호
      authority: '', // 발급기관
      issuedDate: '', // 발급일 (YYYYMMDD)
      foreignAuthority: '', // 외국인 발급기관
      foreignIssuedDate: '', // 외국인 발급일
      collateralNo: '', // 외국인 일련번호
      checkResult: false, // 실명증표 인증 여부
      certDate: '', // 인증 날짜
    },

    parentalContract: {
      // 계약자와의 관계
      relationCode: '', // 고객정보확인 > 계약자와의 관계 코드 (1: 배우자, 2: 자녀, 3: 부, 4: 모, 5: 기타)
      relationName: '', // 고객정보확인 > 계약자와의 관계 기타인 경우 직접입력란
      parentRight: {
        realName: {
          certType: '', //'1',
          authority: '', //'발급기관',
          issuedDate: '', //'2021.08.20',
          licenseCode: '', // 운전면허증 선택 시 지역코드
          licenseNumber: '', // 면허번호
          encodeLicenseNumber: '',
          custTypeCode: '', //'99',
          custTypeName: '', //'그 외 일반 개인',
          checkResult: false, // 실명증표 인증 여부
          certDate: '', // 인증 날짜
        },
      },
    },

    // 면담정보(LP)
    interview: {
      // 계약자
      owner: {
        interviewName: '', // 피대면자 성명
        interviewDate: '', // 대면일자 (YYYY.MM.DD)
        interviewPlace: '', // 대면장소
      },
      // 피보험자
      insured: {
        interviewName: '', // 피대면자 성명
        interviewDate: '', // 대면일자 (YYYY.MM.DD)
        interviewPlace: '', // 대면장소
      },
    },
    // 심사 참고사항(FP)
    insured: {
      picularity: '', // 심사 특이사항 - 기존 존재
      denial: '', // 거절여부 - 추가
    },
    // 모집 경로(FP)
    recruitment: {
      moPath: '', // 선택 ex) 가족/친척
      moType: '', // 소개 선택 -> A: 가족/친척, B:전직장동료, C:친구지인, D:SNS채널, E:기계약자
    },
    // 판매 체크리스트
    checkList: {
      checkAll: 'N', // 전체선택 Y/N
      chk1: 'N', // 주계약 및 특약별 보험료 설명
      chk2: 'N', // 주계약 및 특약 담보내용, 보험금 설명
      chk3: 'N', // 보험료 납입기간 및 보험기간 설명
      chk4: 'N', // 보험회사 명칭, 보험상품 종목
      chk5: 'N', // 청약 철회
      chk6: 'N', // 지급한도
      chk7: 'N', // 고지의무
      chk8: 'N', // 계약취소
      chk9: 'N', // 해약환급금
      chk10: 'N', // 분쟁조정절차
      chk11: 'N', // 설계사의 모집경력
      chk12: 'N', // 설계사의 성명
      chk13: 'N', // 설계사의 보험계약
      chk14: 'N', // 설계사의 보험료
      chk15: 'N', // 해약환급금 미지급
      check_variable: 'N', // 변액보험 Y/N
      chk16: 'N', // 보험계약자의 보험계약
      chk17: 'Y', // 상품설명서
      chk18: 'Y', // 보험계약청약서
      chk19: 'Y', // 보험약관
      check_65up01: 'N', // 고령층 보험상품 (계약자 65세 이상)
      check_65up02: 'N', // 지정대리청구제도
      chk20: 'N', // 장애인
      check_cancel: 'N', // 건강파트너 종신보험(해약환급금 미지급형)(4211) 여부
    },

    satLpReport: {
      // SNS 활용내용
      sns: {
        useSns: '', // 활용 , 미활용
        snsType: '', // 고객발굴, 고객관리, 고객근황파악, 기타
      },
      joinMotivation: [], // 가입동기
      recommend: '', // 가망소개여부
      salesMarket: '', // 판매시장 구분
      // 청약시까지 Activity
      activity: {
        ap: '', // 1회, 2회 ...
        pr: '', // 1회, 2회 ...
      },
      // difficulty: '', // 어려웠던점
      salary: '', // 연수입
      family: {
        marriage: '', // 결혼여부 기혼 , 미혼
        child: '', // 자녀 수
      },
    },

    // 비교안내문
    // 비교안내문: 타사계약 있는지 여부 ['Y' / 'N']
    otcpInsrnPolicyYN: '',

    // 비교안내문: 보험 종류
    insuranceCategory: '',
    insuranceCategory2: '',

    // 비교안내문: 비교설명 완료 여부 ['Y' / 'N']
    insuarnceExplainYN: '',

    // 비교안내문: 타사 계약 - 공시이율(list1), 해약환급금만(list2)
    otherContractDetailInfo: {
      list1: [],
      list2: [],
    },

    // 비교안내문: 수기 입력 계약 (list1~2)
    newContractInfo: {
      // 수기 계약 데이터는 화면에서 최대 2개까지 추가
      // list1: [],
      // list2: [],
    },

    // 비교안내문: Omni에서만 사용하는 값으로 전자청약은 사용하지 않음
    splitData: [],
  },

  // 공동청약 정보
  sharedLp: [
    // 데이터 예시
    // - /api/plan/subscription/sharedLp/${planEstablishNo} API의 리턴 데이터에
    // - /api/plan/subscription/sharedLpInfo/${policyNo} 에서 jointApplicationRate 값을 추가한다
    // {
    //   "agentEmpNo": "1329369",
    //   "jointApplicationRank": 1,
    //   "jointApplicationRate": 50,
    //   "agentEmpNm": "방연중",
    //   "agentPhoneNumber": "010-4504-6272",
    //   "deptCd": "50009722",
    //   "deptNm": "케이비라이프파트너스",
    //   "agencyCd": "833BL",
    //   "agencyNm": "대산",
    //   "agentGrdCd": null,
    //   "planEstbJntApplNo": 1,
    //   "planEstbNo": "234422"
    // },
  ],

  // 보험설계사 서명
  signData: {
    lpSignInfo: { signData: '', nameData: '' },
  },

  insuranceCompareData: {}, // 비교 안내문 API 데이터

  checkListYn: '', // 체크리스트 노출 여부
};

const omniReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case 'INIT_EA_STATE':
      return {
        ...INIT_STATE,
        isShowOmniPopup: state.isShowOmniPopup,
      };
    case 'CHANGE_OMNI_STATE':
      return {
        ...state,
        [action.payload.type]: action.payload.data,
      };
    case 'SHOW_OMNI_POPUP':
      return {
        ...state,
        isShowOmniPopup: true,
      };
    case 'HIDE_OMNI_POPUP':
      return {
        ...state,
        isShowOmniPopup: false,
      };
    case 'OMNI_SEARCH_DOC_DATA_JSON':
      return {
        ...state,
        eaDocDataJson: action.payload,
      };
    case 'SEARCH_FP_JSON_DATA_SUCCESS':
      return {
        ...state,
        completePage:
          action.payload.completePage === undefined
            ? []
            : action.payload.completePage,
        appCompletePage:
          action.payload.appCompletePage === undefined
            ? []
            : action.payload.appCompletePage,
        customerInfo:
          action.payload.customerInfo === undefined
            ? []
            : action.payload.customerInfo,
        fpReport: {
          ...action.payload.fpReport,

          // 실명증표
          realName:
            action.payload.fpReport.realName === undefined
              ? state.fpReport.realName
              : action.payload.fpReport.realName,
          // 면담정보(LP)
          interview:
            action.payload.fpReport.interview === undefined
              ? state.fpReport.interview
              : action.payload.fpReport.interview,
          // 심사 참고사항(FP)
          insured:
            action.payload.fpReport.insured === undefined
              ? state.fpReport.insured
              : action.payload.fpReport.insured,
          // 모집 경로(FP)
          recruitment:
            action.payload.fpReport.recruitment === undefined
              ? state.fpReport.recruitment
              : action.payload.fpReport.recruitment,
          // 판매 체크리스트
          checkList:
            action.payload.fpReport.checkList === undefined
              ? state.fpReport.checkList
              : action.payload.fpReport.checkList,
          satLpReport:
            action.payload.fpReport.satLpReport === undefined
              ? state.fpReport.satLpReport
              : action.payload.fpReport.satLpReport,
          parentalContract:
            action.payload.fpReport.parentalContract === undefined
              ? state.fpReport.parentalContract
              : action.payload.fpReport.parentalContract,
        },
        isContinue:
          action.payload.isContinue === undefined
            ? false
            : action.payload.isContinue,
        appIsContinue:
          action.payload.appIsContinue === undefined
            ? false
            : action.payload.appIsContinue,
        isRewriteComplete:
          action.payload.isRewriteComplete === undefined
            ? false
            : action.payload.isRewriteComplete,
      };
    case 'OMNI_SAVE_SIGNATURE_DATA_SUCCESS':
      return {
        ...state,
        signData: {
          ...state.signData,
          [action.payload.key]: action.payload.data,
        },
      };
    case 'SET_OMNI_PRODUCT_DETAIL':
      return {
        ...state,
        productDetail: action.payload,
      };
    case 'CHANGE_OMNI_FP_REPORT':
      return {
        ...state,
        fpReport: {
          ...state.fpReport,
          [action.payload.key]: action.payload.data,
        },
      };
    case 'SAVE_FP_REPORT_SHARED_LP':
      return {
        ...state,
        sharedLp: action.payload,
      };

    default:
      return state;
  }
};
export default omniReducer;
